import React from 'react';

class PACESlider extends React.Component {
  constructor(props) {
    super(props);
    this.refreshSlider = this.refreshSlider.bind(this);
  }

  static setHoverStyles(id, color) {
    // Create or update dynamic CSS for hover styles
    const styleId = `pace-slider-hover-${id}`;
    let styleElement = document.getElementById(styleId);

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    // Override the existing styles with the dynamic color and ensure proper sizing
    const css = `
      #oneonone-epa-${id}.ui-slider .ui-slider-handle {
        background: ${color} !important;
        border: 1px solid ${color} !important;
        height: 12px !important;
        width: 12px !important;
        border-radius: 50% !important;
        margin: 0px !important;
        margin-left: -1px !important;
        top: -5px !important;
      }
      #oneonone-epa-${id}.ui-slider .ui-slider-handle.ui-state-hover,
      #oneonone-epa-${id}.ui-slider .ui-slider-handle.ui-state-active,
      #oneonone-epa-${id}.ui-slider .ui-slider-handle.ui-state-focus {
        background: ${color} !important;
        border: 1px solid ${color} !important;
        height: 12px !important;
        width: 12px !important;
      }
      #oneonone-epa-${id}.ui-slider-horizontal .ui-slider-range-min {
        background: ${color} !important;
      }
    `;

    styleElement.innerHTML = css;
  }

  componentDidMount() {
    const { id, value, color, onSliderStart, onSliderEnd } = this.props;
    const _this = this;
    this.epaSlider = document.getElementById(`oneonone-epa-${id}`);
    $(this.epaSlider).slider({
      orientation: 'horizontal',
      range: 'min',
      min: 1,
      max: 5,
      step: 1,
      change: _this.refreshSlider,
      slide: _this.refreshSlider,
      start: function(event, ui) {
        if (onSliderStart) {
          onSliderStart();
        }
      },
      stop: function(event, ui) {
        if (onSliderEnd) {
          onSliderEnd();
        }
      },
      value,
      disabled: this.props.disabled,
    });

    // Set the color for the slider bar and handle
    if (color) {
      console.log('color', color);
      // Set colors for both range types to ensure compatibility
      $(`#oneonone-epa-${id} .ui-slider-range`).css('background-color', color);
      $(`#oneonone-epa-${id} .ui-slider-range-min`).css('background-color', color);

      // Ensure proper slider height for custom attributes
      $(`#oneonone-epa-${id}.ui-slider-horizontal`).css('height', '4px');

      // Set dynamic styles to ensure proper sizing and colors
      PACESlider.setHoverStyles(id, color);
    }
  }

  componentDidUpdate(prevProps) {
    const { id, color } = this.props;
    if (color && color !== prevProps.color) {
      // Set colors for both range types to ensure compatibility
      $(`#oneonone-epa-${id} .ui-slider-range`).css('background-color', color);
      $(`#oneonone-epa-${id} .ui-slider-range-min`).css('background-color', color);

      // Ensure proper slider height for custom attributes
      $(`#oneonone-epa-${id}.ui-slider-horizontal`).css('height', '4px');

      // Update dynamic styles when color changes
      PACESlider.setHoverStyles(id, color);
    }
  }

  refreshSlider(event, ui) {
    const { stateId, parent } = this.props;
    const { value } = ui;

    // Handle custom pace attributes differently
    if (stateId.includes('custom_')) {
      const attributeId = Number(stateId.replace('custom_', ''));
      const updatedCustomRatings = parent.state.pace_values.custom_pace_ratings.map(rating => {
        if (rating.attributeId === attributeId) {
          return { ...rating, rating: value };
        }
        return rating;
      });

      parent.setState({
        pace_values: {
          ...parent.state.pace_values,
          custom_pace_ratings: updatedCustomRatings
        },
      });
    } else {
      // Handle standard attributes
      parent.setState({
        pace_values: { ...parent.state.pace_values, [`${stateId}`]: value },
      });
    }

    parent.updateCoachingText(stateId, value);
  }

  render() {
    const { props } = this;
    const { id } = props;
    const class_suffix = props.class_suffix || '';
    return (
      <div className={`oneonone-epa-level oneonone-epa-level-${class_suffix}`}>
        <div className="left">
          <div className="epa-level-bar">
            <div id={`oneonone-epa-${id}`} className="epas-slider" />
            <div className="wb-ui-slider-steps">
              <span className="wb-ui-slider-tick" />
              <span className="wb-ui-slider-tick" style={{ left: '25%' }} />
              <span className="wb-ui-slider-tick" style={{ left: '50%' }} />
              <span className="wb-ui-slider-tick" style={{ left: '75%' }} />
              <span className="wb-ui-slider-tick" style={{ left: '100%' }} />
            </div>
          </div>
        </div>
        <div className="right">
          <div className="oneonone-epa-value" id={`oneonone-epa-${id}-value`} style={{ color: props.color }}>{props.value}</div>
        </div>
      </div>
    );
  }
}
export default PACESlider;
